import { FC, ReactNode, useEffect, useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useActiveSectionContext } from '../context/active-section-context';

interface IProps {
  id?: string;
  title?: string;
  children: ReactNode;
  className?: string;
}

const Section: FC<IProps> = ({ id, children, title, className = '' }) => {
  const [wasInView, setWasInView] = useState(false);
  const { activeSectionId, setActiveSectionId } = useActiveSectionContext();
  const { ref, inView } = useInView({ threshold: 0.1 });

  const introVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 1 } },
  };

  useEffect(() => {
    if (!wasInView && inView) {
      setWasInView(true);
    }

    if (inView && id && activeSectionId !== id) {
      setActiveSectionId(id);
    }
  }, [inView]);

  return (
    <motion.section
      id={id}
      ref={ref}
      variants={introVariants}
      initial="hidden"
      animate={wasInView ? 'visible' : 'hidden'}
      className={`section container ${className}`}
    >
      {title ? <h1 className="section__title">{title}</h1> : null}
      {children}
    </motion.section>
  );
};

export default Section;
